export default class DateParser {

    constructor(date) {

        this.date = date;
    }

    static fromString(value) {

        const matches = value.match(/(?<day>\d{1,2})\.(?<month>\d{1,2})\.(?<year>\d{2,4})/);
        if (matches && matches.length)
            return new DateParser(new Date(`${matches.groups.year}-${matches.groups.month}-${matches.groups.day}`));

        const date = new Date(value);
        if (date)
            return new DateParser(date);

        throw new Error(`Unknown date format: ${value}`);
    }

    static parse(value) {

        return DateParser.fromString(new String(value));
    }

    getFullYear() {

        return this.date.getFullYear();
    }

    getFullMonth() {

        const
            formatter = Intl.DateTimeFormat(DateParser.getLocale(), {month: 'long'}),
            month = formatter.format(this.date);

        return month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
    }

    static getMonths() {

        const
            formatter = Intl.DateTimeFormat(DateParser.getLocale(), {month: 'long'}),
            result = {};

        for (let i = 1; i <= 12; i++) {
            
            const
                l = i < 10 ? `0${i}` : i,
                date = `2000/${l}/01 00:00:00`;

            result[i] = formatter.format(new Date(date));
        }

        return result;
    }

    static getLocale() {

        if (navigator.languages != undefined) 
            return navigator.languages[0];
        
        return navigator.language;
    }
}